import { BaseEntityDto } from '@eva/types/dto';

import type { GenericContextType } from './generic-context';

import { containersContexts } from '../shared/constants';

export interface SocketEventMeta {
  eventTime: string; // '2022-05-27 07:29:21+00:00'
  userId: number;
  entityId: number;
  eventType: string; // 'cbe.skill.created'
  traceId: string; // '47bc5a87-40e7-4481-8936-53abafeb7163'
  companyId: string; // 'devundp'
  persistent: boolean;
  priority: number;
  version: number;
}

export type Immutable<V> = {
  toJS: () => V;
};

export type MaybeImmutable<V> = Immutable<V> | V;

export const isImmutable = <V>(val: MaybeImmutable<V>): val is Immutable<V> => (val as Immutable<V>)?.toJS != null;

export interface ListedResponse<T> {
  items: T[];
  total: number;
}

export type ContainerContext = ValuesOf<typeof containersContexts>;

export type EntityActionName = 'archive' | 'unarchive' | 'manualStatusChange';

export interface EntityActionDescriptor {
  showCondition: <E extends BaseEntityDto>(entity: E, context?: GenericContextType) => boolean;
}
